import React, { useEffect, useState } from 'react';
import { Loader2, Trophy, ChevronRight } from 'lucide-react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '../ui';
import { getTorneosParaInscribir } from '../../lib/services/inscripciones';
import { useOrganization } from '../../contexts/OrganizationContext';
import { fixMojibake } from '../../lib/utils';

// Selector de torneo para inscribir un grupo desde su ficha.
//
// SOLO torneos internos (2026-09-05). Antes listaba tambien los de la red (invitacion
// aceptada) con un distintivo "Organizas" para distinguirlos: era la unica lista de la
// app que mezclaba los dos mundos, y el dueno lo dijo cuatro veces: nunca una lista que
// junte los dos. En un torneo de la red se inscribe desde MYKLUBB Torneos, que tiene su
// boton por torneo.
//
// Era un portal a mano con su propio fondo y su propia tarjeta; ahora es el Dialog de
// la base, que en telefono es pantalla completa como los demas.
const fecha = (v) => (v ? new Date(`${v}T00:00:00`).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' }) : null);
const formatFechas = (inicio, fin) => {
  if (!inicio && !fin) return null;
  if (inicio && fin) return `${fecha(inicio)} – ${fecha(fin)}`;
  return inicio ? `Desde ${fecha(inicio)}` : `Hasta ${fecha(fin)}`;
};

const ElegirTorneoModal = ({ excluirTorneoIds = [], onSelect, onClose }) => {
  const { org } = useOrganization();
  const [torneos, setTorneos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      const { data } = await getTorneosParaInscribir(org?.id || null);
      if (!mounted) return;
      const excl = new Set(excluirTorneoIds);
      setTorneos((data || []).filter((t) => !excl.has(t.id)));
      setLoading(false);
    })();
    return () => { mounted = false; };
  }, [org?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dialog open onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Inscribir a un torneo interno</DialogTitle>
          <DialogDescription>
            Solo torneos que organiza tu club. Para uno de la red, ve a MYKLUBB Torneos.
          </DialogDescription>
        </DialogHeader>

        {loading ? (
          <div className="flex items-center justify-center gap-2 py-8 text-sm text-muted-foreground">
            <Loader2 className="h-4 w-4 animate-spin" /> Cargando torneos...
          </div>
        ) : torneos.length === 0 ? (
          <div className="px-4 py-8 text-center">
            <Trophy className="mx-auto mb-3 h-10 w-10 text-muted-foreground opacity-30" />
            <p className="text-sm text-muted-foreground">
              No hay torneos internos abiertos, o este grupo ya está inscrito en todos.
            </p>
            <p className="mt-1 text-xs text-muted-foreground">
              Crea el torneo en Torneos internos. Para un torneo de la red, inscríbelo desde MYKLUBB Torneos.
            </p>
          </div>
        ) : (
          <div className="space-y-2">
            {torneos.map((t) => (
              <button
                key={t.id}
                type="button"
                onClick={() => onSelect(t)}
                className="flex w-full items-center gap-3 rounded-lg border p-3 text-left transition hover:bg-muted/50"
              >
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium">{fixMojibake(t.nombre || 'Torneo')}</p>
                  {/* Liga y fechas: con varios torneos abiertos, el nombre solo no basta
                      para reconocer cual es. */}
                  <p className="truncate text-xs text-muted-foreground">
                    {[t.ligas?.nombre ? fixMojibake(t.ligas.nombre) : null, formatFechas(t.fecha_inicio, t.fecha_fin)].filter(Boolean).join(' · ')}
                  </p>
                </div>
                <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />
              </button>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ElegirTorneoModal;
